import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@repo/lib/cn';
import { Loader2Icon } from 'lucide-react';

export interface LoadingOverlayProps extends ComponentProps<'div'> {
  isLoading: boolean;
  fullscreen?: boolean;
  children?: ReactNode;
}

export function LoadingOverlay(loadingOverlayProps: LoadingOverlayProps) {
  const { isLoading, fullscreen = false, className, children, ...divProps } = loadingOverlayProps;

  if (!isLoading) {
    return null;
  }

  return (
    <div
      className={cn(fullscreen ? 'fixed inset-0' : 'absolute inset-0', 'bg-background/75 z-60 m-auto flex flex-col items-center justify-center gap-3 backdrop-blur-md', className)}
      aria-live={'polite'}
      aria-busy={'true'}
      {...divProps}
    >
      {children}
    </div>
  );
}

export function LoadingOverlaySpinner(loadingOverlaySpinnerProps: ComponentProps<'svg'>) {
  const { className, ...props } = loadingOverlaySpinnerProps;

  return <Loader2Icon className={cn('animate-spin', className)} aria-hidden={'true'} {...props} />;
}

export function LoadingOverlayLabel(loadingOverlayLabelProps: ComponentProps<'h5'>) {
  const { className, children, ...props } = loadingOverlayLabelProps;

  if (!children) {
    return null;
  }

  return (
    <h5 className={cn('font-medium', className)} {...props}>
      {children}
    </h5>
  );
}
